import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Col, Row, Container } from 'react-bootstrap';
import messages from '../../assets/i18n'
import { HeaderActions, FooterActions, ButtonStandard, ToastMessage, InfoBoard, DateLabel } from '../../components';
import { UploadFiles } from '../../components';
import LoadingControl from '../../containers/LoadingControl/LoadingControl'
import { Creators as actionChart } from '../../store/ducks/measurementChart';

export default function MeasurementChart(props) {

  const dispatch = useDispatch();
  const lang = useSelector(state => state.language.name);
  const { chart, loading, sendChart } = useSelector(state => state.measurementChart)
  const orderList = useSelector(state => state.orderList);
  const idPedido = useRef(0);

  const ACCEPT_TYPE = 'application/pdf';
  const [showToast, setShowToast] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(undefined);
  const [messageError, setMessageError] = useState('');
  const [messageType, setMessageType] = useState('toast-error');
  
  const titlePage = () => {
    return <>
        {(orderList[0] ? messages[lang].Order + ' ' + orderList[0].id : '')}
        <span className="font-weight-normal"> - {messages[lang].importMeasurementChart}</span> 
      </>
  }

  const pageBack = () => {
    dispatch(actionChart.chartClean());
    props.history.push('/main')
  }

	const removeFile = () => {
    setUploadedFile(undefined);
  };
  
  useEffect(() => {
    if (orderList[0]) {
      idPedido.current = orderList[0].id;
    }
  }, [orderList])

  
  useEffect(() => {
    if (sendChart.result === false) {
      setShowToast(true);
      setMessageError(messages[lang].messagesCode.default);
      setUploadedFile(undefined);
    } else if (sendChart.result === true) {
      setShowToast(true);
      setMessageError(messages[lang].messagesCode.chart001);
      setMessageType('toast-success');
      setUploadedFile(undefined);
    }
  }, [sendChart.result, lang])

  useEffect(() => {
    if(orderList[0] && sendChart.result) {
      dispatch({type: 'GET_CHART', payload: orderList[0].id});
    }
  }, [dispatch, orderList, sendChart.result])

  const validateAndStoreLocalFile = file => {

    setUploadedFile(undefined);

		if (!file || file.length === 0) {
      setShowToast(true);
      setMessageError(messages[lang].mustBePDF);
		} else if (file.length > 1) {
			setShowToast(true);
      setMessageError(messages[lang].sendInvoice);
		} else if (file[0].type !== ACCEPT_TYPE) {
			setShowToast(true);
      setMessageError(messages[lang].mustBePDF);
		} else if (file[0].size > 2097152) { 
      // 2MB
			setShowToast(true);
      setMessageError(messages[lang].fileSizeExceeded);
		} else {
      setUploadedFile(file[0]);
    }

	};

  const handleButtonImport = (orderId) => {
    if (uploadedFile) {
      let idPedidoValue = idPedido.current
      dispatch({type: 'SET_CHART', payload: {idPedido: idPedidoValue, file: uploadedFile}})
    }
  }

  const buttonImport = () => (
    <ButtonStandard
      id="measurement-chart-import_button"
      text={messages[lang].import}
      isloading={sendChart.loading}
      disabled={!uploadedFile}
      className="btn btn-primary px-3 py-2 btn-light"
      onClick={handleButtonImport}
    />
  )

  return (
    <div className="measurement-chart-page">
      <HeaderActions titlePage={titlePage()} pageBack={pageBack} />

      <ToastMessage show={showToast} setShow={setShowToast} message={messageError} toastClass={messageType} />

      <LoadingControl isLoadingPage={loading}>
        <Container className="mt-3 mb-5 pb-5">
          {
            chart && chart.dataInclusao && 
              <Row className="mt-3 mb-5 text-center">
                <Col>
                  <InfoBoard title={messages[lang].chartsIncludeDate} body={<DateLabel date={new Date(chart.dataInclusao)} />} />
                </Col>
                <Col>
                  <InfoBoard title={messages[lang].fileName} body={chart.nomeArquivo} />
                </Col>
              </Row>
          }
          <Row className="mt-3 mb-5 text-center">
            <Col>
              <InfoBoard title={messages[lang].importNewFile} body={
                <UploadFiles
                  accept={ACCEPT_TYPE}
                  validateAndStoreLocalFile={validateAndStoreLocalFile}
                  uploadedFile={uploadedFile}
                  removeFile={removeFile}
                />} />
            </Col>
          </Row>
        </Container>
      </LoadingControl>

      <FooterActions ButtonGroupRight={buttonImport} />
    </div>
  );
}
